(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('.disclosure__list-wrapper'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
      
      //  修复：初始化 mega menu 滚动控制
      this.initMegaMenuScrollFix();
    }
    
    /**
     *  核心修复函数：处理 mega menu 滚动问题
     */
    initMegaMenuScrollFix() {
      // 等待 DOM 完全加载
      setTimeout(() => {
        // 查找所有可能的滚动容器
        const scrollContainers = document.querySelectorAll(
          '.products-mega-menu__container, .mega-menu__content[style*="overflow"], [class*="mega-menu"][style*="overflow"]'
        );
        
        scrollContainers.forEach(container => {
          // 确保容器有正确的滚动属性
          container.style.overscrollBehavior = 'contain';
          container.style.overflowY = 'auto';
          
          //  修复1: 防止滚动事件穿透
          container.addEventListener('wheel', (e) => {
            const delta = e.deltaY;
            const scrollTop = container.scrollTop;
            const scrollHeight = container.scrollHeight;
            const clientHeight = container.clientHeight;
            
            // 计算是否在顶部或底部
            const isAtTop = scrollTop === 0;
            const isAtBottom = Math.abs(scrollTop + clientHeight - scrollHeight) < 1;
            
            // 如果在边界且试图继续滚动，阻止事件
            if ((isAtTop && delta < 0) || (isAtBottom && delta > 0)) {
              e.preventDefault();
              e.stopPropagation();
              return false;
            }
            
            // 在可滚动范围内，阻止事件冒泡到 window
            e.stopPropagation();
          }, { passive: false }); //  关键：必须是 non-passive 才能 preventDefault
          
          //  修复2: 处理触摸滚动（移动端）
          let touchStartY = 0;
          container.addEventListener('touchstart', (e) => {
            touchStartY = e.touches[0].clientY;
          }, { passive: true });
          
          container.addEventListener('touchmove', (e) => {
            const touchY = e.touches[0].clientY;
            const scrollTop = container.scrollTop;
            const scrollHeight = container.scrollHeight;
            const clientHeight = container.clientHeight;
            
            const isAtTop = scrollTop === 0;
            const isAtBottom = Math.abs(scrollTop + clientHeight - scrollHeight) < 1;
            const isScrollingUp = touchY > touchStartY;
            const isScrollingDown = touchY < touchStartY;
            
            if ((isAtTop && isScrollingUp) || (isAtBottom && isScrollingDown)) {
              e.preventDefault();
            }
          }, { passive: false });
        });
        
        // 🔧 修复3: 处理子元素（链接、卡片）的滚动
        const childElements = document.querySelectorAll(
          '.products-mega-menu__content, .products-mega-menu__cards, .full-unstyled-link'
        );
        
        childElements.forEach(element => {
          // 确保子元素不会自己滚动
          element.style.overflow = 'visible';
          
          // 为这些元素添加 wheel 监听，让滚动只发生在父容器
          element.addEventListener('wheel', (e) => {
            // 找到最近的滚动容器
            const scrollContainer = element.closest('.products-mega-menu__container, [style*="overflow-y"]');
            
            if (scrollContainer) {
              // 让滚动事件在容器上处理
              const wheelEvent = new WheelEvent('wheel', {
                deltaY: e.deltaY,
                deltaX: e.deltaX,
                deltaZ: e.deltaZ,
                deltaMode: e.deltaMode,
                bubbles: false
              });
              
              scrollContainer.dispatchEvent(wheelEvent);
              e.preventDefault();
              e.stopPropagation();
            }
          }, { passive: false });
        });
        
      }, 500); // 延迟以确保 mega menu 已渲染
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);
  
  class StaticHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }
  }

  customElements.define('static-header', StaticHeader);

  } catch(e) { console.error(e); }
})();
})();
